import { create } from 'zustand'

interface UIState {
  mobileNavOpen: boolean
  activeMegaMenu: string | null  // category slug of open mega menu
  searchOpen: boolean

  openMobileNav: () => void
  closeMobileNav: () => void
  toggleMobileNav: () => void

  openMegaMenu: (slug: string) => void
  closeMegaMenu: () => void

  openSearch: () => void
  closeSearch: () => void
}

export const useUIStore = create<UIState>()((set) => ({
  mobileNavOpen: false,
  activeMegaMenu: null,
  searchOpen: false,

  openMobileNav: () => set({ mobileNavOpen: true }),
  closeMobileNav: () => set({ mobileNavOpen: false }),
  toggleMobileNav: () => set((s) => ({ mobileNavOpen: !s.mobileNavOpen })),

  openMegaMenu: (slug) => set({ activeMegaMenu: slug }),
  closeMegaMenu: () => set({ activeMegaMenu: null }),

  openSearch: () => set({ searchOpen: true }),
  closeSearch: () => set({ searchOpen: false }),
}))